module.exports = __webpack_public_path__ + "static/media/Blue.2226fd8e.png";